import { useContext } from 'react';

import { TabBarContext } from './TabBarContext';

export const TabPanel = ({ whenActive, children }) => {
  const tabBarContext = useContext(TabBarContext);
  return whenActive === tabBarContext.activeTab ? children : null;
};
